export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-stone-800 text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          <div>
            <h3
              className="text-2xl font-semibold mb-4"
              style={{ fontFamily: "'Cormorant Garamond', serif" }}
            >
              K LINN Interiors
            </h3>
            <p
              className="text-sm text-gray-300 leading-relaxed mb-6"
              style={{ fontFamily: "'Montserrat', sans-serif" }}
            >
              Creating sophisticated, timeless spaces that reflect your unique personality and enhance your everyday living.
            </p>
            <div className="flex gap-3">
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 flex items-center justify-center bg-white/10 rounded-full hover:bg-amber-600 transition-colors cursor-pointer"
              >
                <i className="ri-instagram-line text-base"></i>
              </a>
              <a
                href="https://pinterest.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 flex items-center justify-center bg-white/10 rounded-full hover:bg-amber-600 transition-colors cursor-pointer"
              >
                <i className="ri-pinterest-line text-base"></i>
              </a>
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 flex items-center justify-center bg-white/10 rounded-full hover:bg-amber-600 transition-colors cursor-pointer"
              >
                <i className="ri-facebook-line text-base"></i>
              </a>
            </div>
          </div>

          <div>
            <h4
              className="text-lg font-semibold mb-4"
              style={{ fontFamily: "'Cormorant Garamond', serif" }}
            >
              Quick Links
            </h4>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-sm text-gray-300 hover:text-amber-500 transition-colors cursor-pointer"
                  style={{ fontFamily: "'Montserrat', sans-serif" }}
                >
                  Services
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('portfolio')}
                  className="text-sm text-gray-300 hover:text-amber-500 transition-colors cursor-pointer"
                  style={{ fontFamily: "'Montserrat', sans-serif" }}
                >
                  Portfolio
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('about')}
                  className="text-sm text-gray-300 hover:text-amber-500 transition-colors cursor-pointer"
                  style={{ fontFamily: "'Montserrat', sans-serif" }}
                >
                  About
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('process')}
                  className="text-sm text-gray-300 hover:text-amber-500 transition-colors cursor-pointer"
                  style={{ fontFamily: "'Montserrat', sans-serif" }}
                >
                  Process
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4
              className="text-lg font-semibold mb-4"
              style={{ fontFamily: "'Cormorant Garamond', serif" }}
            >
              Services
            </h4>
            <ul className="space-y-2">
              <li>
                <span
                  className="text-sm text-gray-300"
                  style={{ fontFamily: "'Montserrat', sans-serif" }}
                >
                  Residential Design
                </span>
              </li>
              <li>
                <span
                  className="text-sm text-gray-300"
                  style={{ fontFamily: "'Montserrat', sans-serif" }}
                >
                  Commercial Design
                </span>
              </li>
              <li>
                <span
                  className="text-sm text-gray-300"
                  style={{ fontFamily: "'Montserrat', sans-serif" }}
                >
                  Design Consultation
                </span>
              </li>
              <li>
                <span
                  className="text-sm text-gray-300"
                  style={{ fontFamily: "'Montserrat', sans-serif" }}
                >
                  Custom Furniture
                </span>
              </li>
            </ul>
          </div>

          <div>
            <h4
              className="text-lg font-semibold mb-4"
              style={{ fontFamily: "'Cormorant Garamond', serif" }}
            >
              Contact
            </h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-2">
                <i className="ri-phone-line text-amber-500 mt-1"></i>
                <span
                  className="text-sm text-gray-300"
                  style={{ fontFamily: "'Montserrat', sans-serif" }}
                >
                  (555) 123-4567
                </span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-mail-line text-amber-500 mt-1"></i>
                <span
                  className="text-sm text-gray-300"
                  style={{ fontFamily: "'Montserrat', sans-serif" }}
                >
                  hello@klinninteriors.com
                </span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line text-amber-500 mt-1"></i>
                <span
                  className="text-sm text-gray-300"
                  style={{ fontFamily: "'Montserrat', sans-serif" }}
                >
                  Grand Rapids, Michigan<br />
                  Saint Thomas
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p
              className="text-sm text-gray-400"
              style={{ fontFamily: "'Montserrat', sans-serif" }}
            >
              © 2024 K LINN Interiors. All rights reserved.
            </p>
            <a
              href="https://readdy.ai/?ref=logo"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-gray-400 hover:text-amber-500 transition-colors cursor-pointer"
              style={{ fontFamily: "'Montserrat', sans-serif" }}
            >
              Website Builder
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}